import React from 'react';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';

const columns = [
    {
        field: 'orderNum',
        headerName: 'SO Number',
        flex: 1, 
        minWidth: 75,
        editable: false
    },
    {
        field: 'poNum',
        headerName: 'PO Number',
        flex: 1,
        minWidth: 75,
        editable: false
    },  
    {
        field: 'orderId',
        headerName: 'Geodis ID',
        flex: 1,
        minWidth: 75,
        editable: false
    },
    {
        field: 'carrier',
        headerName: 'Carrier',
        flex: 1,
        minWidth: 75,
        editable: false
    },
    {
        field: 'shipmentDate',
        headerName: 'Shipment Date',
        flex: 1,
        minWidth: 100,
        valueGetter: (params) => {
            if(!params.row.shipmentDate) return "";
            return params.row.shipmentDate.substring(0, 10)
        }, 
        editable: false
    },
    {
        field: 'shippedQuantityTotal',
        headerName: 'Shipped Quantity',
        flex: 1,
        minWidth: 150,
        valueGetter: (params) => {
            let totalShippedQuantity = 0;
            // Loop through each carton and sum the shippedQuantity from the line items
            params.row.shipment.carton.forEach(carton => {
                carton.line.forEach(line => {
                    line.lotInfo.forEach(lot => {
                        totalShippedQuantity += parseInt(lot.shippedQuantity, 10) || 0; // Safely parse the quantity
                    });
                });
            });
            return totalShippedQuantity;
        },
        editable: false
    }
]

function Get3PLShipmentConfirmationTable(props) {

    return(
        <Box className = {props.isMobile ? "mobile-box" : "desktop-box"}>
            <Box className = {props.isMobile ? "mobile-table-box" : "desktop-table-box"}>
                <DataGrid
                    className = {props.isMobile ? "mobile-table" : "desktop-table"}
                    sx = {{height:"1000px"}}
                    rows = {props.orders}
                    columns = {columns}
                    rowsPerPageOption = {[25, 50, 100]}
                    checkboxSelection = {false}
                    onRowClick = {props.setOpenDetails}
                    getRowId = {(row) => row.orderNum}
                />
            </Box>
        </Box>
    )
}

export default Get3PLShipmentConfirmationTable;